<template>
  <!-- 公用右侧编辑企业名称头部组件 -->
  <section class="edit-form-header">
    <el-form label-width="80px">
      <el-form-item label="企业名称" :hide-required-asterisk="true">
        <div style="display: flex; justify-content: space-between">
          <el-input
            class="inner"
            type="text"
            v-model="datas.enterpriseName"
            placeholder="请输入企业名称"
            style="flex: 6;margin-left: 35px;"
          />
          <div style="flex: 4; text-align: right">
            <el-button
              style=""
              class="custom-btn-allow"
              size="small"
              @click="handleResteChange('#348cF8')"
              >重置</el-button
            >
            <!-- <button
              class="carousel-btn consult-btn"
              @click="handleResteChange"
              style="
                height: 30px;
                line-height: 26px;
                padding: 2px 13px;
                font-size: 13px;
              "
            >
              重置
            </button> -->
          </div>
        </div>
      </el-form-item>
      <el-form-item label="主题色" class="theme-color-item">
        <ThemeColorSelector
          style="margin-left: 38px"
          :isTitle="false"
          v-model="datas.customColor"
          :customColor="datas.customColor"
          :selected-color="selectedThemeColor"
          @color-change="handleThemeColorChange"
        >
          <template #customColor>
            <div class="custom-button-container">
              自定义
              <el-color-picker
                v-model="datas.customColor"
                show-alpha
                @change="handleCustomColorChange"
              ></el-color-picker>
            </div>
          </template>
        </ThemeColorSelector>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
// 引入主题色选择子组件
import ThemeColorSelector from "@/components/public/ThemeColorSelector/ThemeColorSelector.vue";
export default {
  name: "editFormheader",
  components: {
    ThemeColorSelector,
  },
  props: {
    datas: Object,
  },
  data() {
    return {
      selectedThemeColor: "#348CF8",
      // customColor: "",
    };
  },
  mounted() {},
  methods: {
    // 主题色重置
    handleResteChange(color) {
      this.$utils.setCssVariable("theme-primary", color);
      // 初始化datas中的datas.customColor为null
      // 初始化自定义选色版
       this.customColor = null;
      this.datas.customColor = color;
      // 初始化选中色板块
      this.selectedThemeColor = color;
      console.log("主题色重置了", this.datas);
    },
    // 自定义主题色组件回调  整个中间预览区相关组件的颜色
    handleCustomColorChange(color) {
      this.customColor = color;
      this.selectedThemeColor = null;
      if (color == null) {
        this.selectedThemeColor = "#1890ff";
      }
      // 动态修改全局 CSS 变量 --theme-primary
      this.$utils.setCssVariable("theme-primary", color);
      console.log("子组件中自定义颜色", color, this.customColor);
    },
    // 主题色组件回调  整个中间预览区相关组件的颜色
    handleThemeColorChange(color) {
      // 动态修改全局 CSS 变量 --theme-primary
      //  this.$utils.getCssVariable("theme-primary"),  获取公共root颜色
      this.$utils.setCssVariable("theme-primary", color);
      console.log(
        "子组件中主题色选择",
        color,
        this.$utils.getCssVariable("theme-primary"),
      );

      this.selectedThemeColor = color;
      this.customColor = null;
    },
    tab(val, key, index) {
      console.log("点击了", val, key, index, this.tabType);
      for (let i in this.tabType) {
        if (key == i) {
          this.tabType[key] = true;
          this.$set(this.data, "tabType", key);
        } else {
          this.tabType[i] = false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-input--small .el-input__inner {
  border: 2px solid red !important;
}
section {
  // height: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}
.theme-color-item {
  margin-bottom: 0px !important;
}
</style>
